import messages from './myCases.json' with { type: 'json' };

export const myCasesEn: Readonly<typeof messages> = messages;
